module.exports = __webpack_public_path__ + "img/comments.12f5c5c8.png";